// @ts-check
/// <reference path="../types/global.d.ts" />

if (!customElements.get("product-faq")) {
  customElements.define(
    "product-faq",
    class ProductFAQ extends HTMLElement {
      constructor() {
        super();
        this.geoToggle();
        if (this.dataset.multipleSelect === "true") return;

        /** @type {NodeListOf<HTMLDetailsElement>} */
        this.details = this.querySelectorAll(".product-detail-accordions__detail");
        this.details.length && this.handleSingleOpen();
      }

      handleSingleOpen() {
        this.details?.forEach((accordion) => {
          accordion.addEventListener("click", (e) => {
            e.preventDefault();

            if (accordion.open) {
              this.handleCloseAll();
            } else {
              this.handleCloseAll();
              accordion.setAttribute("open", "");
              const summaryElement = accordion.querySelector("summary");
              summaryElement?.setAttribute("aria-expanded", "true");
              summaryElement?.focus();
            }
          });
        });
      }

      handleCloseAll() {
        this.details?.forEach((accordion) => {
          accordion.removeAttribute("open");
          const summaryElement = accordion.querySelector("summary");
          summaryElement?.setAttribute("aria-expanded", "false");
        });
      }

      geoToggle() {
        const { geoip2 } = window;
        if (!geoip2) return;

        /** @type {NodeListOf<HTMLDivElement>} */
        const geoTabs = this.querySelectorAll(".product-detail-accordions__accordion[data-geolocation]");
        if (!geoTabs.length) return;

        geoTabs.forEach((tab) => tab.classList.remove("geo-show"));
        geoip2.city(
          (geoipResponse) => {
            geoTabs.forEach((tab) => {
              const allowedLocations = tab.dataset.geolocation?.split(",");

              if (allowedLocations?.length) {
                const allGeonames = [
                  ...geoipResponse.subdivisions.map((callbackfn) => callbackfn.geoname_id),
                  geoipResponse.city.geoname_id,
                  geoipResponse.country.geoname_id,
                  geoipResponse.continent.geoname_id,
                ];

                const isAllowed = allGeonames.some((geoname) =>
                  allowedLocations.some((allowedLocation) => parseInt(allowedLocation.trim()) === geoname)
                );

                if (isAllowed) {
                  tab.classList.add("geo-show");
                }
              } else {
                tab.classList.add("geo-show");
              }
            });
          },
          (error) => {
            console.error(error);
          }
        );
      }
    }
  );
}
